import React, { useEffect, useState } from 'react';
import '../styles/HomeHeroSection.css';

import pr1 from '../assets/p1x.png';
import pr2 from '../assets/p2x.jpg';
import pr3 from '../assets/p3x.jpg';

const slides = [pr1, pr2, pr3];

export default function HomeHeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto slide every 8 seconds
  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentSlide((previous) => (previous + 1) % slides.length);
    }, 8000);

    return () => window.clearInterval(timer);
  }, []);

  // Previous slide
  const handlePrevious = () => {
    setCurrentSlide((previous) =>
      previous === 0 ? slides.length - 1 : previous - 1
    );
  };

  // Next slide
  const handleNext = () => {
    setCurrentSlide((previous) =>
      (previous + 1) % slides.length
    );
  };

  return (
    <section
      id="home"
      className="home-hero-section"
      aria-label="Preferred Audiology highlights"
    >
      <div className="home-hero-background">

        {/* Slides */}
        {slides.map((src, index) => (
          <div
            key={src}
            className={`home-hero-slide${
              index === currentSlide ? ' home-hero-active' : ''
            }`}
            aria-hidden={index !== currentSlide}
          >
            <img
              src={src}
              alt={
                index === currentSlide
                  ? `Preferred Audiology banner ${index + 1}`
                  : ''
              }
              className="home-hero-image"
              loading={index === 0 ? 'eager' : 'lazy'}
            />
          </div>
        ))}

        {/* Previous Button */}
        <button
          type="button"
          className="home-hero-arrow home-hero-prev"
          onClick={handlePrevious}
          aria-label="Previous banner"
        >
          <i className="fa-solid fa-chevron-left"></i>
        </button>

        {/* Next Button */}
        <button
          type="button"
          className="home-hero-arrow home-hero-next"
          onClick={handleNext}
          aria-label="Next banner"
        >
          <i className="fa-solid fa-chevron-right"></i>
        </button>

      </div>
    </section>
  );
}